export default `End Game
-=0
K=0
B=0
D=0
P=0
S=0
F=0

xxxxxxxxxxxxxxx
x             x
x x x x x x x x
x             x
x x x x x x x x
x             x
x x 3 1 2 4 x x
x             x
x x x x x x x x
x             x
x x x x x x x x
x             x
xxxxxxxxxxxxxxx`
